import { VisitorID } from "./components/visitor-id.js";
import { getBrowserType } from "./core/utils.js";
import { checkNewTabButtonTarget } from "./components/cta-new-tab.js";
import { initCampaign } from "./components/journey-tracker.js";
import { form } from "./components/form.js";
import { waba } from "./components/waba-trigger.js";
import { checkChannelParams } from "./components/channel-params.js";
import { initCTAPartner } from "./components/cta-partner.js";
import { initWabaTracking } from "./components/utm-tracker.js";
import { initInquiryParallelSubmit } from "./components/waba-inquiry.js";
import { ContactAutoTrack } from './components/auto-contact-track.js';

(function ($) {
    "use strict";

    const visitorID = VisitorID.init();

    function checkStickyWABA() {
        var stickyWABA = document.querySelector(".ic-wa");
        if (!stickyWABA) {
            var scrollTop = document.querySelector("#scroll-top");
            if (scrollTop) {
                scrollTop.classList.add("alt");
            }
        }
    }

    initWabaTracking({
        csv: {
            mediumUrl: document.querySelector("#medium_file")?.value || "",
            campaignUrl: document.querySelector("#campaign_file")?.value || "",
        },
        ttlDays: 31,
        debug: false,
        channelCodes: {
            medium: { "organic direct": "P6A", "organic search": "P5A" },
            campaign: { default: "MP" },
        },
    }).then(({ code, ccode, updated, source }) => {
        checkStickyWABA();
        getBrowserType();
        checkNewTabButtonTarget();
        waba();
        initCampaign();
        checkChannelParams();
        form();
        initCTAPartner();
        initInquiryParallelSubmit({
            formSelector: 'form[data-inquiry-tracking="true"]',
            scriptURL:
                "https://script.google.com/macros/s/AKfycbytpmoIa9Rn3eMxMyF3B0JizfPZ_S7Bm0kpuCfSpYt5WAyeSy1eNXVVepr9SajCkN70qw/exec",
            buttonSelectors: ["#submit-inquiry-form", ".btn-submit"],
        });
    });

    ContactAutoTrack.init();
})(jQuery);
